export default __webpack_public_path__ + "static/media/timeline_example.f0d468e3.jpg";